import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Layout from "./components/layout";
import Dashboard from "./components/pages/Dashboard";
import EmployeeList from "./components/Employee/EmployeeList";
import UserList from "./components/User/UserList";
import Login from "./components/Login";
import ChatPage from "./components/pages/ChatPage";
import UserContext from "./context/UserContext";
import ChatPermissionManager from "./components/Chat/ChatDashboard/ChatPermissionManager";
import BroadcastPage from "./components/pages/BroadcastPage";
import TaskJDList from "./components/TaskJD/TaskJDList";
import TaskDailyList from "./components/Taskdailly/TaskDailyList";
import { BroadcastProvider } from "./context/BroadcastContext";
import DepartmentList from "./components/Department/DepartmentList";
import DailyDashboard from "./components/DailyDashboard/DailyDashboard";
import ProjectList from "./components/Project/ProjectList";
import MyWorkDashboard from "./components/UserDashboard/MyWorkDashboard";
import AttendanceSystem from "./components/AttendanceSystem/AttendanceSystem";
import AttendanceDashboard from "./components/AttendanceDashboard/AttendanceDashboard";
import LeaveManagement from "./components/LeaveManagement/LeaveManagement"; 
import LeaveApproval from "./components/LeaveApproval/LeaveApproval";
import LeaveApprovalDetail from "./components/LeaveApproval/LeaveApprovalDetail";
import KPIList from "./components/KPI/KPIList";
import DivisionList from "./components/Division/DivisionList";
import UserProfilePage from "./components/UserProfilePage/UserProfilePage";
import AnnualLeaveManagement from "./components/AnnualLeaveManagement/AnnualLeaveManagement";
import DelegationList from "./components/Delegation/DelegationList";
import AttendanceMatrix from "./components/AttendanceMatrix/AttendanceMatrix";
import OTApprovalConfigList from "./components/OTApprovalConfig/OTApprovalConfigList";
import OTManagement from "./components/OTManagement/OTManagement";
import OTApproval from "./components/OTApproval/OTApproval";
import OTApprovalDetail from "./components/OTApproval/OTApprovalDetail";
import LeaveAdminManagement from "./components/LeaveManagement/LeaveAdminManagement";
import RegulationList from "./components/Regulations/RegulationList";
import RegulationUserView from "./components/Regulations/RegulationUserView";
import PaymentApprovalDetail from "./components/PaymentApproval/PaymentApprovalDetail";

import PaymentApprovalConfigList from "./components/PaymentApprovalConfig/PaymentApprovalConfigList";

import PaymentManagement from "./components/PaymentManagement/PaymentManagement";

import PaymentApproval from "./components/PaymentApproval/PaymentApproval";
import PaymentAdminManagement from "./components/PaymentManagement/PaymentAdminManagement";
import OTAdminManagement from "./components/OTManagement/OTAdminManagement";
import SupplierList from "./components/Supplier/SupplierList";
import MenuList from "./components/Menu/MenuList";

import PermissionManager from "./components/Menu/PermissionManager";
import LeaveApprovalConfigList from "./components/LeaveConfig/LeaveApprovalConfigList";

function App() {
  const location = useLocation();
  const [loading, setLoading] = useState(true); // Thêm trạng thái chờ load session
  const [user, setUser] = useState(null);

  // 1. Khởi tạo User từ localStorage một lần duy nhất khi mount
  useEffect(() => {
    const savedUser = localStorage.getItem("user");
    if (savedUser) {
      try {
        setUser(JSON.parse(savedUser));
      } catch (error) {
        localStorage.removeItem("user");
      }
    }
    setLoading(false); // Xong bước kiểm tra session
  }, []);

  // 2. Cập nhật localStorage khi user thay đổi
  useEffect(() => {
    if (user) {
      localStorage.setItem("user", JSON.stringify(user));
    } else if (loading === false) {
      localStorage.removeItem("user");
      localStorage.removeItem("token");
    }
  }, [user, loading]);

  // Nếu đang kiểm tra session thì hiện màn hình trống/spinner, tránh redirect bậy
  if (loading) return null; 

  return (
    <UserContext.Provider value={{ user, setUser }}>
      <BroadcastProvider>
        <Routes>
          {/* Nếu đã login mà vào /login, giữ nguyên ở trang hiện tại hoặc về trang chủ */}
          <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
          
          <Route path="/" element={user ? <Layout /> : <Navigate to="/login" state={{ from: location }} replace />}>
            {/* THAY ĐỔI QUAN TRỌNG: Đừng dùng Navigate ở trang Index nếu không muốn bị đá về attendance */}
            <Route index element={<MyWorkDashboard />} /> 
            
            <Route path="attendance" element={<AttendanceSystem />} />
            <Route path="dashboard-main" element={<Dashboard />} />
            <Route path="employee-list" element={<EmployeeList />} />
            <Route path="user-list" element={<UserList />} />
            <Route path="chat" element={<ChatPage />} />
            <Route path="broadcast" element={<BroadcastPage />} />
            <Route path="chat-dashboard" element={<ChatPermissionManager />} />
            <Route path="task-jd-list" element={<TaskJDList />} />
            <Route path="department-list" element={<DepartmentList />} />
            <Route path="task-dailly-list" element={<TaskDailyList />} />
            <Route path="task-dailly-report" element={<DailyDashboard />} />
            <Route path="project-list" element={<ProjectList />} />
            <Route path="dashboard" element={<MyWorkDashboard />} />
            <Route path="attendance-dashboard" element={<AttendanceDashboard />} />
            <Route path="leave-management" element={<LeaveManagement />} />
            <Route path="leave-approval" element={<LeaveApproval />} />
            <Route path="approve-leave/:id" element={<LeaveApprovalDetail />} />
            <Route path="kpi-user" element={<KPIList />} />
            <Route path="division-list" element={<DivisionList />} />
            <Route path="profile" element={<UserProfilePage />} />
            <Route path="annualleavemanagement" element={<AnnualLeaveManagement />} />
            <Route path="delegationlist" element={<DelegationList />} />
            <Route path="calculate-merit" element={<AttendanceMatrix />} />
            <Route path="otapprovalconfig-list" element={<OTApprovalConfigList />} />
            <Route path="ot-management" element={<OTManagement />} />
            <Route path="ot-approval" element={<OTApproval />} />
            <Route path="ot-approval-detail/:id" element={<OTApprovalDetail />} />
            <Route path="leave-admin-management" element={<LeaveAdminManagement />} />
            <Route path="regulation-list" element={<RegulationList />} />
            <Route path="regulation-user-view" element={<RegulationUserView />} />
            <Route path="paymentapprovalconfig-list" element={<PaymentApprovalConfigList />} />
            <Route path="payment-management" element={<PaymentManagement />} />
            <Route path="payment-approval" element={<PaymentApproval />} />
            <Route path="payment-approval-detail/:id" element={<PaymentApprovalDetail />} />
            <Route path="payment-admin-management" element={<PaymentAdminManagement />} />
             <Route path="ot-admin-management" element={<OTAdminManagement />} />
             <Route path="supplier-list" element={<SupplierList />} />
             <Route path="menu-list" element={<MenuList />} />
             <Route path="permissionmanager" element={<PermissionManager />} />
             <Route path="leave-approvalconfig-list" element={<LeaveApprovalConfigList />} />
          </Route>
          
          {/* Nếu path không tồn tại, chỉ về trang chủ chứ không ép vào attendance */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BroadcastProvider>
    </UserContext.Provider>
  );
}

export default App;